<template>
  <Loader v-if="loading" />
  <div
    class="wrapper"
    v-else
  >
    <Sidebar v-if="$route.path !== '/login'" />
    <div class="main">
      <Navbar v-if="$route.path !== '/login'" />
      <main class="content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/Sidebar.vue";
import Navbar from "./components/Navbar.vue";
import Loader from "./pages/Loader.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "App",
  components: { Sidebar, Navbar, Loader },
  computed: {
    ...mapState(["loading"])
  },
  mounted() {
    this.start();
  },
  methods: {
    ...mapActions(["start"])
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue